import * as React from 'react';
import {Link} from "react-router-dom";
import {logOut} from "../../utilities/Utilities";

interface Props {
    active: number
}

export const Menu = (props: Props) => {

    return <>
        <section id={'menu'}>
            <h3>Menu</h3>
            <hr/>
            <ul>
                <Link to={'/konto'}>
                    <li className={props.active === 1 ? "active" : ""}>Moje konto</li>
                </Link>
                <Link to={'/karta'}>
                    <li className={props.active === 2 ? "active" : ""}>Karta</li>
                </Link>
                <Link to={'/twojsklep'}>
                    <li className={props.active === 5 ? "active" : ""}>Twój sklep stacjonarny</li>
                </Link>
                {/*<Link to={'/reklamacje'}>*/}
                {/*    <li className={props.active === 3 ? "active" : ""}>Reklamacje</li>*/}
                {/*</Link>*/}
                <Link to={'#'} onClick={()=>logOut()}>
                    <li className={props.active === 4 ? "active" : ""}>Wyloguj</li>
                </Link>
            </ul>
        </section>
    </>

}

Menu.defaultProps = {}

